import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import {gql} from '@apollo/client';

import {brandUrl} from '../../../util/url';

import './PopularBrands.css';

const BrandItem = memo(function BrandItem({ name, showDivider }) {
    return (
        <>
            <Link className="PopularBrands-item" to={brandUrl(name)}>
                {name}
            </Link>
            {showDivider && <div className="PopularBrands-divider" aria-hidden="true" />}
        </>
    );
});

BrandItem.propTypes = {
    name: PropTypes.string.isRequired,
    showDivider: PropTypes.bool,
};

const POPULAR_BRANDS = gql`
    {
      getPopularKeywordsByFilterCached {
        popularBrands {
            name
        }
      }
    }
`;

/**
 * 홈화면 인기브랜드 섹션
 * @returns {JSX.Element}
 * @constructor
 */
export default function PopularBrands() {
    const { data } = useQuery(POPULAR_BRANDS);

    const brands = (data?.getPopularKeywordsByFilterCached?.popularBrands ?? []).slice(0, 8);

    return (
        <section className="PopularBrands">
            <div className="PopularBrands-inner">
                <div className="PopularBrands-header">
                    <div className="PopularBrands-tag">Popular Brands</div>
                    <h2 className="PopularBrands-title">인기 브랜드</h2>
                </div>
                <div className="PopularBrands-row">
                    {brands.map((brand, index) => (
                        <BrandItem
                            key={brand.name}
                            name={brand.name}
                            showDivider={index < brands.length - 1}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
PopularBrands.propTypes = {};
